<template>
  <div class="d-calendar-list">
    <div class="d-calendar-list__header" :class="{'d-calendar-list__header--flex': isCalendarInPrintMode}">
      <h4>{{ calendarName }}</h4>
      <p>{{ dateRangeFormatted }}</p>
    </div>
    <table>
      <tbody>
      <tr v-if="eventsSortedInDays.length < 1">
        <td class="text-explainer pad-1">
          {{ i18n['no_lessons']}}
        </td>
      </tr>
      <tr v-for="event in eventsSortedInDays" :key="event.id"
          :class="{'tr--is-day': event.type && event.type === 'dayDate'}">
        <template v-if="event.type && event.type === 'dayDate'">
          <td colspan="4">
            <div>
              <p>{{ event.showDay }}</p>
              <p>{{ event.showDate }}</p>
            </div>
          </td>
        </template>
        <template v-else>
          <td>
            <div class="lesson">
              {{ event.v_start }} - {{ event.v_end }}
              <div class="lesson__dot" :style="{'backgroundColor': event.color}"></div>
              <p>{{ event.title }}<template v-if="event.group.length > 0">, {{ event.group }}</template></p>
            </div>
          </td>
          <td>
            <span class="icon-user" v-if="event.teacher.length > 0"></span> {{ event.teacher }}
          </td>
          <td>
            <span class="icon-users3" v-if="event.substitutes.length > 0"></span> {{ event.substitutes }}
          </td>
          <td>
            <span class="icon-location" v-if="event.room.length > 0"></span> {{ event.room }}
          </td>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

const I18N = {
  da: {
    no_lessons: 'Der er ingen lektioner i denne uge'
  },
  en: {
    no_lessons: 'No lessons this week'
  },
  nb: {
    no_lessons: 'Ingen leksjoner denne uken'
  }
}

export default {
  props: {
    calendarName: {
      default: 'DCalendarList'
    },
    events: {
      type: Array,
      default: () => []
    },
    date: {
      default: () => moment()
    },
    isShowWeekends: {
      type: Boolean,
      default: false
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    isCalendarInPrintMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    startDate () {
      return moment(this.date).isoWeekday(this.firstDayOfWeek)
    },
    endDate () {
      const endDayNum = this.isShowWeekends ? this.firstDayOfWeek + 6 : this.firstDayOfWeek + 4
      return moment(this.date).isoWeekday(endDayNum)
    },
    dateRangeFormatted () {
      const isSameYear = moment(this.startDate).format('YYYY') === moment(this.endDate).format('YYYY')
      const start = isSameYear ? moment(this.startDate).format('DD MMM') : moment(this.startDate).format('ll')
      const end = moment(this.endDate).format('ll')
      return start + ' - ' + end
    },
    filteredEvents () {
      return this.events
    },
    sortedEvents () {
      return this.filteredEvents.sort((a, b) => {
        return moment(a.start).unix() - moment(b.start).unix()
      })
    },
    eventsSortedInDays () {
      const eventsAndDays = []
      this.sortedEvents.forEach((event, idx) => {
        event.v_start = moment(event.start).format('LT')
        event.v_end = moment(event.end).format('LT')
        if (event.event_type === 'presence') {
          event.title = this.$t('vue2.task_overview.work_hours')
          event.color = '#d9e9fb'
        }
        const startTime = event.start
        const dateObj = {
          id: startTime,
          type: 'dayDate',
          start: moment(startTime).format('YYYY-MM-DD'),
          showDay: moment(startTime).format('dddd'),
          showDate: moment(startTime).format('LL')
        }
        if (idx === 0) {
          eventsAndDays.push(dateObj)
        }
        if (idx > 0 && moment(event.start).format('YYYY-MM-DD') !== moment(this.sortedEvents[idx - 1].start).format('YYYY-MM-DD')) {
          eventsAndDays.push(dateObj)
        }
        eventsAndDays.push(event)
      })
      return eventsAndDays
    }
  }
}
</script>

<style scoped>
.d-calendar-list {
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  font-size: 13px;
}

.d-calendar-list__header {
  text-align: center;
  border-bottom: 1px solid #d9d9d9;
  font-weight: bold;
}

.d-calendar-list__header.d-calendar-list__header--flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-calendar-list table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.d-calendar-list table tbody tr {
  border-bottom: 1px solid #d8d8d8;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.d-calendar-list table tbody tr:first-child {
  border-top: 0;
}

.tr--is-day {
  background: #f9fafb;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1rem;
  color: #8c919c;
}

.d-calendar-list table tr td {
  padding: 0.25rem 0.5rem;
}

.d-calendar-list table tr:not(.tr--is-day) td {
  font-weight: normal;
}

.tr--is-day > td > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lesson {
  display: flex;
  align-items: center;
}

.lesson__dot {
  width: 1rem;
  height: 1rem;
  margin: 0 1rem;
  background-color: aliceblue;
  border-radius: 50%;
}



</style>



// WEBPACK FOOTER //
// DCalendarList.vue?657ef58a